import { getFlagUrl } from '@va/util/helpers';

export const MapPin = ({ countryCodeAlpha2, count }: { countryCodeAlpha2: string; count: number }) => {
  return (
    <foreignObject width='80' height='15'>
      <div
        className={
          'bg-white inline-flex items-center text-[0.625rem] px-2px rounded-full align-top cursor-default pointer-events-none'
        }
      >
        <img src={getFlagUrl(countryCodeAlpha2, '1x1')} className={'w-3 h-3 rounded-full'} alt={countryCodeAlpha2} />
        &nbsp;{count}
      </div>
    </foreignObject>
  );
};
